export default __webpack_public_path__ + "static/thumb-landscape-ecb9afcf45812a4e8e3c46ecb21f0dcd.jpg";